var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-quotation-yes"},[_c('confirmation-content',[_c('div',{staticClass:"confirmation-content__title confirmation-content__title--margin-bottom"},[_vm._v(" Dziękujemy! ")]),_c('div',[_vm._v(" Wkrótce otrzymasz propozycję wyjazdu przygotowaną specjalnie dla Ciebie! ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }